module.exports = __webpack_public_path__ + "static/media/exclamation.17ca41bb.svg";